/* eslint-disable */
import { db as dbInstance, ensureFirebase } from "services/firebase";
import {
    doc,
    getDoc,
    setDoc,
    updateDoc,
    serverTimestamp,
    collection,
    query,
    where,
    getDocs,
    limit,
} from "firebase/firestore";

const nowTs = () => serverTimestamp();
const MEMBERS = "members"; // 명시적 컬렉션명

function getDb() {
    return dbInstance || ensureFirebase().db;
}

/**
 * members/{memberId} 문서 읽기
 * @param {string} memberId
 */
export async function getMember(memberId) {
    const db = getDb();
    const ref = doc(collection(db, MEMBERS), memberId);
    const snap = await getDoc(ref);
    return snap.exists() ? snap.data() : null;
}

/**
 * 전화번호로 멤버 존재 여부 확인
 * @param {string} phoneE164 (+82 형식)
 * @returns {Promise<boolean>}
 */
export async function existsMemberByPhone(phoneE164) {
    if (!phoneE164) return false;
    const db = getDb();
    const q = query(collection(db, MEMBERS), where("PhoneE164", "==", phoneE164), limit(1));
    const qs = await getDocs(q);
    return !qs.empty;
}

/**
 * 전화번호로 memberId 반환
 * @param {string} phoneE164
 * @returns {Promise<string|null>}
 */
export async function getMemberIdByPhone(phoneE164) {
    if (!phoneE164) return null;
    const db = getDb();
    const q = query(collection(db, MEMBERS), where("PhoneE164", "==", phoneE164), limit(1));
    const qs = await getDocs(q);
    return qs.empty ? null : qs.docs[0].id;
}

/**
 * 전화번호 기준 멤버 생성/업데이트 (없으면 생성, 있으면 갱신)
 * @param {string} phoneE164 (+82)
 * @param {object} payload members 문서 데이터
 * @returns {Promise<string>} memberId
 */
export async function upsertMemberByPhone(phoneE164, payload = {}) {
    if (!phoneE164) throw new Error("[membersService] phoneE164 required");

    const db = getDb();
    const colMembers = collection(db, MEMBERS);
    let memberId = null;

    // 전화번호 기준 조회
    const q = query(colMembers, where("PhoneE164", "==", phoneE164), limit(1));
    const qs = await getDocs(q);

    if (qs.empty) {
        // 신규 생성
        const ref = doc(colMembers); // Firestore 자동 ID
        const base = {
            memberId: ref.id,
            PhoneE164: phoneE164,
            createdAt: nowTs(),
            updatedAt: nowTs(),
            active: true,
            status: "active",
            ...payload,
        };
        await setDoc(ref, base);
        memberId = ref.id;
    } else {
        // 기존 멤버 갱신
        const ref = qs.docs[0].ref;
        await updateDoc(ref, { ...payload, updatedAt: nowTs() });
        memberId = ref.id;
    }

    return memberId;
}

/**
 * 상태 업데이트 (예: suspend / active)
 */
export async function setMemberStatus(memberId, status = "active") {
    if (!memberId) return false;
    const db = getDb();
    const ref = doc(collection(db, MEMBERS), memberId);
    await updateDoc(ref, { status, updatedAt: nowTs() });
    return true;
}

/**
 * 기본 프로필 업데이트 (표시 이름 등)
 */
export async function updateMemberProfile(memberId, profilePatch = {}) {
    if (!memberId) return false;
    const db = getDb();
    const ref = doc(collection(db, MEMBERS), memberId);
    await updateDoc(ref, {
        profile: profilePatch,
        updatedAt: nowTs(),
    });
    return true;
}

export default {
    getMember,
    existsMemberByPhone,
    getMemberIdByPhone,
    upsertMemberByPhone,
    setMemberStatus,
    updateMemberProfile,
};
